import { useContext, useState } from "react";
import primaryComponents from "../../../../../components/primaryComponents";
import { useMutation, useQueryClient } from "react-query";
import { updateReconciledStockDate } from "../../../../../services/inventory";
import { ToastContext } from "../../../../../hooks/context";

export const StockCountDate = ({
  reconciliationDetails = {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    stock_count_date: reconciliationDetails?.stock_count_date || "",
  });

  const { mutate: updateStockDate, isLoading: isSubmitting } = useMutation(
    (data) => updateReconciledStockDate(data),
  );

  const handleUpdateDate = () => {
    updateStockDate(
      {
        id: reconciliationDetails?.id,
        data: {
          ...formData,
        },
      },
      {
        onSuccess: () => {
          triggerToast("Stock Count Date Updated", "success");
          queryClient.invalidateQueries([
            "getReconciliationDetails",
            `${reconciliationDetails?.id}`,
          ]);
        },
      },
    );
  };

  return (
    <div>
      <primaryComponents.DateInput
        label="Stock Count Date"
        value={formData?.stock_count_date}
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, stock_count_date: value }));
        }}
      />

      <primaryComponents.Button
        classNames={"mt-4 btn btn--primary w-100"}
        onClick={() => handleUpdateDate()}
        isDisabled={isSubmitting}
        isLoading={isSubmitting}
      >
        Update Date
      </primaryComponents.Button>
    </div>
  );
};
